/**
 * Pure validation for the OAuth authorize hop query string.
 * Kept out of the React page so UI only translates / renders (SRP).
 */

export type OAuthAuthorizeParamsError = 'missingParams' | 'unsupportedResponseType'

export type OAuthAuthorizeQuery = {
  clientId: string
  redirectUri: string
  responseType: string
}

export function validateOAuthAuthorizeQuery(
  query: OAuthAuthorizeQuery
): OAuthAuthorizeParamsError | null {
  if (!query.clientId || !query.redirectUri) {
    return 'missingParams'
  }
  if (query.responseType !== 'code') {
    return 'unsupportedResponseType'
  }
  return null
}
